import './Programme.css';
import { getEventIcon } from '../../utils/getEventIcon';


import ProgrammeDay from './components/ProgrammeDay';

import ProgrammeNavigation from './components/ProgrammeNavigation';

export default function Programme() {

    const days = getProgramme();

    return `

        <section class="programme">

            <div class="container">

                <h1>

                    Conference Programme

                </h1>

                <div class="programme-layout">

                    ${ProgrammeNavigation(days)}

                    <div class="programme-content">

                        ${days
                            .map(day => ProgrammeDay(day))
                            .join('')}

                    </div>

                </div>

            </div>

        </section>

    `;

}
